module.exports = __webpack_public_path__ + "static/media/11.62f66887.png";